import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_tenant_orders_list, loading_retrieve_tenant_orders_list, reset_retrieve_tenant_orders_list, success_retrieve_tenant_orders_list } from '../../../../reducers/auth_tenant/retrieve_tenant_orders_list_Slice';
import { RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { TENANT_RETRIEVE_SALES_REP_ORDERS_BY_DATE_API } from '../../../../api/api_data';
import { addThreeDots, formatNumber, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import { Badge, Button, Input } from 'reactstrap';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import CardTabs from '../../../components/cards/CardTabs';
import * as app_consts from "../../../../utils/app_consts";
import moment from 'moment';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const SalesRepDetailsOrderReportsOrders = ({ start_date, end_date, tabName, tenant_info, user_info, sales_rep_id, data }) => {

 const [page_data, setPageData] = useState([]);
 const [date_range, setDateRange] = useState({ start_date: start_date, end_date: end_date });
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const [sent_sales_rep_id, setSentSalesRepID] = useState(sales_rep_id);
 const [current_page_data, setCurrentPageData] = useState([]);
 const [sm, updateSm] = useState(false);
 const [searchTerm, setSearchTerm] = useState((""));
 const [currentPage, setCurrentPage] = useState(1);
 const [itemPerPage] = useState(10);
 const [received_data, setReceivedData] = useState(data);

 useEffect(() => {
  setDateRange({ start_date: start_date, end_date: end_date });
  setSentSalesRepID(sales_rep_id);
  if (tabName === "Orders")
  {
   retrieve_data(start_date, end_date, sales_rep_id);
  }
  setPageData(tabName);
  setReceivedData(data);
 }, [start_date, end_date, tabName, sales_rep_id, data]);

 const retrieve_data = (start_date, end_date, id) => {
  setError("");
  // Get the browser's timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get the browser's timezone offset in minutes
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes > 0 ? "-" : "+";
  const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;

  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_orders_list, success_retrieve_tenant_orders_list, fail_retrieve_tenant_orders_list, RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_SALES_REP_ORDERS_BY_DATE_API}/${id}/${start_date}${formattedOffset}/${end_date}${formattedOffset}`));
 };
 // Listen
 const retrieve_tenant_orders_list_listener = useSelector((state) => state.retrieve_tenant_orders_list.retrieve_tenant_orders_list);

 useEffect(() => {
  if (retrieve_tenant_orders_list_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_orders_list_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (retrieve_tenant_orders_list_listener.status === app_consts.FAIL)
    {
     setError(retrieve_tenant_orders_list_listener.message, app_consts.FAIL);
     messageToast(retrieve_tenant_orders_list_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_orders_list_listener.status === app_consts.SUCCESS)
    {
     setPageData(retrieve_tenant_orders_list_listener.data || []);
     setCurrentPageData(retrieve_tenant_orders_list_listener.data || []);

    }
    dispatch(reset_retrieve_tenant_orders_list());
   }
  }
 }, [retrieve_tenant_orders_list_listener]);


 // Save page to localStorage
 const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);
 };

 // Pagination
 const indexOfLastItem = currentPage * itemPerPage;
 const indexOfFirstItem = indexOfLastItem - itemPerPage;
 const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

 // Filtering by search
 useEffect(() => {
  let filtered = [...page_data];

  // Step 2: Search filter
  if (searchTerm)
  {
   filtered = filtered.filter((item) => {
    const combinedParams = [
     item?.sales_rep?.name,
     item.order_ref_number,
     item.order_name,
     item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
     item.status?.replace(/_/g, " ").toUpperCase(),
    ]
     .join(" ")
     .toLowerCase();
    return combinedParams.includes(searchTerm.toLowerCase());
   });
  }

  // Step 3: Save to state
  setCurrentPageData(filtered);
  setCurrentPage(1);

 }, [searchTerm, page_data]);

 const export_to_csv = (e) => {
  e.preventDefault();
  const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

  const csv_headers = [
   "Order Ref Number",
   "Order Name/Destination",
   "Sales Rep",
   "On Behalf of",
   "Number of Products",
   "Total Products Value (ZMW)",
   "Date Created",
   "Order Type",
   "Status"
  ];

  const csv_data = current_page_data?.map((item) => {
   return {
    order_ref_number: item?.order_ref_number,
    order_name: item?.order_name,
    sales_rep: item?.sales_rep?.name,
    on_behalf_of: item?.behalf_of === app_consts.SELF ? item?.sales_rep?.name : item?.agency?.name,
    number_of_products: item?.no_of_products,
    total_products_value: formatNumber(item?.total_value) || 0.00,
    date_created: item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
    order_type: item?.order_date_type,
    status: item?.status
   };
  });

  const options = mkConfig({
   fieldSeparator: ',',
   quoteStrings: '"',
   showLabels: true,
   showTitle: false,
   title: " ",
   useTextFile: false,
   useBom: true,
   filename: `${received_data?.sales_rep?.name}'s Orders Report from ${date_range?.start_date} to ${date_range?.end_date} as at ${cur_dt}`,
   useKeysAsHeaders: true,
   columnHeaders: csv_headers,
  });

  const csv = generateCsv(options)(csv_data || []);

  download(options)(csv);
 };

 return (
  <>
   <BlockHead size="sm">
    <BlockBetween>
     <BlockHeadContent>
      <BlockDes className="text-soft">
       <p>{!(loading || error) && `Orders ${page_data?.length}`}</p>
      </BlockDes>
      {!(loading) && (
       <div className="mt-2 d-flex justify-content-end mb-3">
        <Link
         onClick={(e) => {
          e.preventDefault();
          retrieve_data(date_range?.start_date, date_range?.end_date, sent_sales_rep_id);
         }}
        >
         <Button color="light" outline className="bg-white d-none d-sm-inline-flex mx-2">
          <span>Refresh List</span>
         </Button>
        </Link>
        <Button
         color="primary"
         className="btn-primary"
         onClick={export_to_csv}
        >
         <Icon name="download-cloud" />
         <span>Export to CSV</span>
        </Button>
       </div>
      )}
     </BlockHeadContent>
     {!(loading || error) && (
      <BlockHeadContent>
       <div className="toggle-wrap nk-block-tools-toggle">
        <a
         href="#more"
         className="btn btn-icon btn-trigger toggle-expand me-n1"
         onClick={(ev) => {
          ev.preventDefault();
          updateSm(!sm);
         }}
        >
         <Icon name="more-v"></Icon>
        </a>
        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
         <ul className="nk-block-tools g-3">
          <li>
           <div className="form-control-wrap">
            <div className="form-icon form-icon-right">
             <Icon name="search"></Icon>
            </div>
            <Input
             type="text"
             className="form-control"
             id="default-04"
             value={searchTerm}
             onChange={e => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
             }}
             placeholder="Search Orders..."
            />
           </div>
          </li>
         </ul>
        </div>
       </div>
      </BlockHeadContent>
     )}
    </BlockBetween>
   </BlockHead>
   {loading ? (
    <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Orders..." />
   ) : error ? (
    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
   ) : page_data && page_data.length > 0 ? (
    <>
     <Block>
      <div className="nk-tb-list is-separate is-medium mb-3">
       <DataTableHead className="nk-tb-item">
        <DataTableRow><span className="sub-text">Order</span></DataTableRow>
        <DataTableRow><span className="sub-text">Sales Rep / Employee</span></DataTableRow>
        <DataTableRow><span className="sub-text">Behalf Of</span></DataTableRow>
        <DataTableRow><span className="sub-text">No Of Products</span></DataTableRow>
        <DataTableRow size="lg"><span className="sub-text">Date Created</span></DataTableRow>
        <DataTableRow size="md"><span className="sub-text">Order Date Type</span></DataTableRow>
        <DataTableRow size="md"><span className="sub-text">Status</span></DataTableRow>
        <DataTableRow><span className="sub-text">Action</span></DataTableRow>
       </DataTableHead>

       {currentItems.length > 0 &&
        currentItems.map((item) => (
         <DataTableItem key={item.id}>
          <DataTableRow>
           <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`} target='_'>
            <div className="user-card">
             <div className="user-info">
              <span className="tb-lead">
               {addThreeDots(item?.order_name || "--", 30)}
              </span>
              <span>{item?.order_ref_number || "--"}</span>
             </div>
            </div>
           </Link>
          </DataTableRow>
          <DataTableRow>
           <span className="tb-lead">{item?.sales_rep?.name || "--"}</span>
          </DataTableRow>
          <DataTableRow>
           <span className="tb-lead">
            {item?.behalf_of === app_consts.SELF
             ? item?.sales_rep?.name
             : item?.agency?.name}
           </span>
          </DataTableRow>
          <DataTableRow>
           <div className="user-card">
            <div className="user-info">
             <span className="tb-lead">{item?.no_of_products || "0"}</span>
             <span>{item?.total_value ? `${formatNumber(item?.total_value)} ZMW` : ""}</span>
            </div>
           </div>
          </DataTableRow>
          <DataTableRow size="md">
           <span className="tb-lead">
            {item?.inserted_at
             ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss")
             : "--"}
           </span>
          </DataTableRow>
          <DataTableRow size="md">
           {item?.order_date_type
            ? formatToSentenceCase(item?.order_date_type)?.toUpperCase()
            : "--"}
          </DataTableRow>
          <DataTableRow size="md">
           <Badge
            color={
             item?.status === app_consts.APPROVED_LOWER ||
              item?.status === app_consts.DISPATCHED_LOWER
              ? "success"
              : "warning"
            }
            className="badge-dot"
           >
            {item?.status
             ? formatToSentenceCase(item?.status)?.toUpperCase()
             : "--"}
           </Badge>
          </DataTableRow>
          <DataTableRow>
           <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`} target='_'>
            <Button color="primary" size="sm" className="btn btn-dim">
             View
            </Button>
           </Link>
          </DataTableRow>
         </DataTableItem>
        ))}
      </div>
      {currentItems.length > 0 && (
       <div className="mt-3">
        <PaginationComponent
         itemPerPage={itemPerPage}
         totalItems={current_page_data?.length}
         paginate={paginate}
         currentPage={currentPage}
        />
       </div>
      )}
     </Block>
    </>
   )
    :
    <>

    </>
   }

  </>
 );
};

export default SalesRepDetailsOrderReportsOrders;